exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2owex{position:absolute;top:0;left:0;right:0;bottom:0;z-index:130}", ""]);

// exports
exports.locals = {
	"slidable-overlay": "_2owex",
	"slidableOverlay": "_2owex"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/mobile/views/home/components/cover-with-overlay/cover-with-overlay.styl
// module id = 2815
// module chunks = mobile/mobile